import React, { useEffect, useState } from "react";
export default function NotificacaoTemporariaErro({
  mostrar,
  onClose,
  mensagem = "Documento gerado com sucesso!",
}) {
  useEffect(() => {
    if (mostrar) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // 5 segundos
      return () => clearTimeout(timer);
    }
  }, [mostrar, onClose]);
  if (!mostrar) return null;
  return (
    <div className="fixed top-5 right-5 bg-red-600 text-white px-4 py-3 rounded-lg shadow-lg z-50 transition-opacity duration-500">
      {mensagem}
    </div>
  );
}
